import React, { useEffect, useRef, useState } from 'react';
import { Wrapper, PageCountWrapper, Content } from './atoms';
import PropTypes from 'prop-types';

const countSuggestion = [10, 15, 30, 45, 99999];

export const PageCountDropdown = (props) => {

  const { elementsCount, onSelect } = props;

  const [isActive, setIsActive] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsActive(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <div className="relative" ref={wrapperRef}>
      <Wrapper onClick={() => { setIsActive(val => !val) }}>
        {elementsCount === 99999 ? 'All' : elementsCount}
        <div className="ml-1 mt-0.5">
          <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.92053 1.01758L3.92053 4.01758L0.920532 1.01758" stroke={window?.settings?.secondary_color ?? '#04333b'} strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      </Wrapper>

      {isActive &&
        <Content>
          {countSuggestion.map(el => (
            <PageCountWrapper key={el} selected={el === elementsCount} onClick={() => { onSelect(el); setIsActive(false) }}>
              {el === 99999 ? 'All' : el}
            </PageCountWrapper>
          ))}
        </Content>
      }
    </div>
  )
}

PageCountDropdown.propTypes = {
  elementsCount: PropTypes.number,
  onSelect: PropTypes.func,
};